document.addEventListener("DOMContentLoaded", () => {
  let activeTrigger = null;
  let activeAttraction = null;
  let attractionCloseTimer = null;
  let attractionAutoCloseTimer = null;

  const getYoutubeEmbedUrl = (url) => {
    try {
      const parsedUrl = new URL(url);
      let videoId = "";

      if (parsedUrl.hostname.includes("youtu.be")) {
        videoId = parsedUrl.pathname.replace("/", "");
      } else if (parsedUrl.pathname.includes("/embed/")) {
        videoId = parsedUrl.pathname.split("/embed/")[1];
      } else if (parsedUrl.pathname.includes("/shorts/")) {
        videoId = parsedUrl.pathname.split("/shorts/")[1];
      } else {
        videoId = parsedUrl.searchParams.get("v") || "";
      }

      videoId = videoId.split(/[/?&]/)[0];

      if (!videoId || videoId === "d3HAmFNnBDg") {
        return "";
      }

      return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    } catch (error) {
      return "";
    }
  };

  const closeLightbox = () => {
    const lightbox = document.querySelector("[data-video-lightbox]");

    if (!lightbox) {
      return;
    }

    lightbox.remove();
    document.body.classList.remove("has-video-lightbox");

    if (activeTrigger) {
      activeTrigger.focus();
      activeTrigger = null;
    }
  };

  const openLightbox = (trigger) => {
    const embedUrl = getYoutubeEmbedUrl(trigger.dataset.videoUrl || "");

    if (!embedUrl) {
      return;
    }

    activeTrigger = trigger;
    closeLightbox();

    const lightbox = document.createElement("div");
    lightbox.className = "video-lightbox";
    lightbox.dataset.videoLightbox = "";
    lightbox.setAttribute("role", "dialog");
    lightbox.setAttribute("aria-modal", "true");
    lightbox.setAttribute("aria-label", "Video");
    lightbox.innerHTML = `
      <button class="video-lightbox__backdrop" type="button" data-video-close aria-label="Fechar video"></button>
      <div class="video-lightbox__dialog">
        <button class="video-lightbox__close" type="button" data-video-close aria-label="Fechar video">&times;</button>
        <iframe class="video-lightbox__iframe" src="${embedUrl}" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </div>
    `;

    document.body.appendChild(lightbox);
    document.body.classList.add("has-video-lightbox");
    lightbox.querySelector(".video-lightbox__close").focus();
  };

  document.querySelectorAll("[data-video-trigger]").forEach((button) => {
    button.addEventListener("click", () => {
      openLightbox(button);
    });
  });

  const clearAttractionCloseTimer = () => {
    if (!attractionCloseTimer) {
      return;
    }

    window.clearTimeout(attractionCloseTimer);
    attractionCloseTimer = null;
  };

  const clearAttractionAutoCloseTimer = () => {
    if (!attractionAutoCloseTimer) {
      return;
    }

    window.clearTimeout(attractionAutoCloseTimer);
    attractionAutoCloseTimer = null;
  };

  const closeAttractionTooltip = () => {
    clearAttractionCloseTimer();
    clearAttractionAutoCloseTimer();

    if (!activeAttraction) {
      return;
    }

    const trigger = activeAttraction.querySelector("[data-map-attraction-trigger]");

    activeAttraction.classList.remove("is-open");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    }

    activeAttraction = null;
  };

  const keepAttractionTooltipInViewport = (attraction) => {
    const tooltip = attraction.querySelector("[data-map-attraction-tooltip]");

    if (!tooltip) {
      return;
    }

    tooltip.style.setProperty("--map-tooltip-shift", "0px");

    const tooltipRect = tooltip.getBoundingClientRect();
    const viewportPadding = 16;
    let shift = 0;

    if (tooltipRect.left < viewportPadding) {
      shift = viewportPadding - tooltipRect.left;
    } else if (tooltipRect.right > window.innerWidth - viewportPadding) {
      shift = window.innerWidth - viewportPadding - tooltipRect.right;
    }

    tooltip.style.setProperty("--map-tooltip-shift", `${shift}px`);
  };

  const scheduleAttractionTooltipClose = () => {
    clearAttractionCloseTimer();

    attractionCloseTimer = window.setTimeout(() => {
      closeAttractionTooltip();
    }, 1200);
  };

  const scheduleAttractionTooltipAutoClose = () => {
    clearAttractionAutoCloseTimer();

    attractionAutoCloseTimer = window.setTimeout(() => {
      closeAttractionTooltip();
    }, 4500);
  };

  const openAttractionTooltip = (attraction, options = {}) => {
    clearAttractionCloseTimer();
    clearAttractionAutoCloseTimer();

    if (activeAttraction && activeAttraction !== attraction) {
      closeAttractionTooltip();
    }

    const trigger = attraction.querySelector("[data-map-attraction-trigger]");

    attraction.classList.add("is-open");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }

    activeAttraction = attraction;
    keepAttractionTooltipInViewport(attraction);

    if (options.autoClose) {
      scheduleAttractionTooltipAutoClose();
    }
  };

  document.querySelectorAll("[data-map-attraction]").forEach((attraction) => {
    const trigger = attraction.querySelector("[data-map-attraction-trigger]");
    const tooltip = attraction.querySelector("[data-map-attraction-tooltip]");
    const hasHoverPointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    if (!trigger) {
      return;
    }

    if (hasHoverPointer) {
      attraction.addEventListener("mouseenter", () => {
        openAttractionTooltip(attraction);
      });

      attraction.addEventListener("mouseleave", () => {
        scheduleAttractionTooltipClose();
      });

      if (tooltip) {
        tooltip.addEventListener("mouseenter", () => {
          openAttractionTooltip(attraction);
        });

        tooltip.addEventListener("mouseleave", () => {
          scheduleAttractionTooltipClose();
        });
      }
    } else if (tooltip) {
      ["touchstart", "pointerdown", "focusin"].forEach((eventName) => {
        tooltip.addEventListener(eventName, () => {
          clearAttractionAutoCloseTimer();
        });
      });

      ["touchend", "pointerup", "focusout"].forEach((eventName) => {
        tooltip.addEventListener(eventName, () => {
          scheduleAttractionTooltipAutoClose();
        });
      });
    }

    trigger.addEventListener("focus", () => {
      if (hasHoverPointer) {
        openAttractionTooltip(attraction);
      }
    });

    trigger.addEventListener("blur", (event) => {
      if (!attraction.contains(event.relatedTarget)) {
        scheduleAttractionTooltipClose();
      }
    });

    trigger.addEventListener("click", (event) => {
      event.stopPropagation();

      if (hasHoverPointer && event.detail > 0) {
        return;
      }

      openAttractionTooltip(attraction, {
        autoClose: !hasHoverPointer,
      });
    });
  });

  window.addEventListener("resize", () => {
    if (activeAttraction) {
      keepAttractionTooltipInViewport(activeAttraction);
    }
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-video-close]")) {
      closeLightbox();
    }

    if (!event.target.closest("[data-map-attraction]")) {
      closeAttractionTooltip();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeLightbox();
      closeAttractionTooltip();
    }
  });
});
